import api from '@/api/index.js'

const bot_client = {
  state: {
    loading: false,
    updating: false,
    data: null,
    error: null
  },

  mutations: {
    SET_BOT_CLIENT_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_BOT_CLIENT: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_BOT_CLIENT_ERROR: (state, error) => {
      state.error = error
    },
    SET_BOT_CLIENT_UPDATING: (state, updating) => {
      state.updating = updating
    }
  },

  actions: {
    LoadBotClient({commit}, query) {
      commit('SET_BOT_CLIENT', null)
      commit('SET_BOT_CLIENT_ERROR', null)
      commit('SET_BOT_CLIENT_LOADING', true)
      return api.get(`bot-clients/${query.id}`)
        .then((response) => {
          commit('SET_BOT_CLIENT', response)
        })
        .catch((error) => {
          commit('SET_BOT_CLIENT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_BOT_CLIENT_LOADING', false)
        })
    },
    DeleteBotClient({commit}, payload) {
      commit('SET_BOT_CLIENT_UPDATING', true);
      commit('SET_ERROR', null);
      commit('SET_BOT_CLIENT_ERROR', null)
      return api.delete(`bot-clients/${payload.id}`)
        .then((response) => {
          commit('SET_BOT_CLIENT', {});
        })
        .catch((error) => {
          commit('SET_BOT_CLIENT_ERROR', error);
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_BOT_CLIENT_UPDATING', false);
        })
    },
    UpdateBotClient({commit}, payload) {
      commit('SET_BOT_CLIENT_UPDATING', true);
      commit('SET_ERROR', null);
      commit('SET_BOT_CLIENT_ERROR', null)
      return api.put(`bot-clients/${payload.id}`, payload.data)
        .then((response) => {
          commit('SET_BOT_CLIENT', response.body);
        })
        .catch((error) => {
          commit('SET_BOT_CLIENT_ERROR', error);
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_BOT_CLIENT_UPDATING', false);
        })
    },
  }
}

export default bot_client
